<template>
  <v-row justify="center">
    <v-col cols="12" sm="8" lg="4">
      <v-card :elevation="1">
        <v-card-title class="text-center">
          ログイン
        </v-card-title>

        <v-card-text>
          <v-alert
            density="compact"
            variant="outlined"
            color="error"
            text="ユーザーIDまたはパスワードが違います"
            class="mb-3"
            v-bind:class="{ 'hidden': !isInvalid }"
          ></v-alert>

          <v-text-field
            label="ユーザーID"
            v-model="userID"
            :readonly="isLockUserID"
          ></v-text-field>

          <v-text-field
            label="パスワード"
            v-model="password"
            type="password"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-btn
            variant="tonal" color="primary" class="w-100"
            v-on:click="getAccessToken">
            ログイン
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { ref } from 'vue';

import rison from 'rison';
import axios from 'axios';

import config from '@/config.js';

export default {
  name: 'AuthenticationView',
  setup() {
    const isInvalid = ref(false);

    const userID = ref('');
    const isLockUserID = ref(false);

    if (location.hash.split('#').length > 2) {
      userID.value = rison.decode_object(location.hash.split('#')[2]).userID;
      isLockUserID.value = true;
    }

    const password = ref('');

    function getAccessToken() {
      isInvalid.value = false;

      if (!(userID.value in config.users)) {
        isInvalid.value = true;
        return;
      }

      const requestParam = new FormData();
      requestParam.append('username', userID.value);
      requestParam.append('password', password.value);

      axios.post(
        'https://trial.agrilog.jp/v2/token',
        requestParam
      ).then((response) => {

        window.sessionStorage.setItem("userID", userID.value);
        window.sessionStorage.setItem("token", response.data.access_token);
        window.location.reload();

      }).catch(() => {
        isInvalid.value = true;
      });
    }

    return {
      isInvalid,

      userID,
      isLockUserID,

      password,

      getAccessToken
    }
  }
}
</script>

<style scoped>
  .hidden {
    visibility: hidden;
  }
</style>
